import React from "react";
import { connect } from "react-redux";
import { toast } from "react-hot-toast";

import { remove as removeAlert } from "../../actions/alert";

export class AlertFeedback extends React.Component {
  componentDidMount() {
    this.flush();
  }

  componentDidUpdate() {
    this.flush();
  }

  flush() {
    (this.props.alerts || []).forEach((alert) => {
      const options = { id: alert.id };

      if (alert.type === "success") {
        toast.success(alert.message, options);
      } else if (alert.type === "error") {
        toast.error(alert.message, options);
      } else if (alert.type === "warning") {
        toast(alert.message, { ...options, icon: "❗" });
      } else {
        toast(alert.message, options);
      }

      this.props.removeAlert(alert.id);
    });
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  alerts: state.alert,
});

export default connect(mapStateToProps, { removeAlert })(AlertFeedback);
